<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="sayfahead m-0">
      <h1><small>Toplantı</small></h1>
      <el-button type="success" size="small" class="YeniBtn"
                 @click="YeniBtn">
        Toplantı Planla
      </el-button>
    </div>
    <el-table
      v-if="Liste"
      :data="Liste"
      class="golgetable">
      <el-table-column
        label="Toplantı Konusu"
        prop="Konu">
      </el-table-column>
      <el-table-column
        label="Toplantı Tarihi"
        prop="tTarihiText">
      </el-table-column>
      <el-table-column
        label="Katılımcı Sayısı"
        prop="Katilimci">
      </el-table-column>

      <el-table-column
        align="right">

        <template slot-scope="scope">
          <el-button-group>
            <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                        placement="top-start">
              <el-button
                size="mini"
                type="primary"
                icon="feather-edit-2"
                @click="DuzenleBtn(scope.row)">
              </el-button>
            </el-tooltip>

            <el-tooltip v-if="Yetki" class="item" effect="dark"
                        content="Sil"
                        placement="top-start">
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete-solid"
                @click="SilOnay(scope.row.id)">
              </el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <BinaYeniToplanti @BinaYeniToplantiModal="SayfaYukle"
                      :BinaYeniToplantiModal="BinaYeniToplantiModal"
                      v-if="BinaYeniToplantiModal"
                      :data="YeniData"></BinaYeniToplanti>
  </div>
</template>

<script>
  import BinaYeniToplanti from "./Toplanti/BinaYeniToplanti";
  import Yukleniyor from "../../../../Doc/Yukleniyor";

  export default {
    props: ['BinaBilgi'],
    components: {Yukleniyor, BinaYeniToplanti},
    data() {
      return {
        lo: true,
        YeniData: {
          Baslik: 'Toplantı Planla',
          Bina_id: null,
          tTarihi: null,
          Konu: null
        },
        Liste: null,
        BinaYeniToplantiModal: false
      }
    },
    methods: {
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {path: 'yonetim/bina/toplanti/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      DuzenleBtn(data) {
        data.Baslik = 'Toplantı Düzenle'
        this.YeniData = data;
        this.BinaYeniToplantiModal = true
      },
      YeniBtn() {
        this.YeniData = {
          Baslik: 'Toplantı Planla',
          Bina_id: this.BinaBilgi.id,
          tTarihi: null,
          Konu: null
        }
        this.BinaYeniToplantiModal = true
      },
      SayfaYukle() {
        this.BinaYeniToplantiModal = false;
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina/toplanti/' + this.BinaBilgi.id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;

            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },

    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.yonetim == '2' ? true : false;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaToplanti.vue